import { db } from "../../firebase";
import { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { Container, Row, Col } from "react-bootstrap";


const Request = () => {
    const [datas, setData] = useState([]);

    const fetchData = async () => {
        const dataRef = ref(db, 'request');
        let data = [];
        onValue(dataRef, (snapshot) => {
            snapshot.forEach(node => {
                data = [...data, node.val()];
            })

            setData([...datas, ...data]);
        });
    };
    useEffect(() => {
        fetchData();
    }, []);
    return (
        <Container style={{
            marginBottom: '24px',
            marginTop: '8px',
            height: '264px',
            overflowY : 'auto'}}>
            <Row className="d-flex justify-content-center">
                <Col md={12}>
                    <Row>
                        <Col style={{ padding: '8px 0' }} className="btn-primary">Name</Col>
                        <Col style={{ padding: '8px 0' }} className="btn-primary">Email</Col>
                        <Col style={{ padding: '8px 0' }} className="btn-primary">Phone</Col>
                        <Col style={{ padding: '8px 0' }} className="btn-primary">Message</Col>
                    </Row>
                    {datas.map((data, index) => (
                        <Row
                            key={index}
                            className={index % 2 === 0 ? 'bg-light' : 'bg-secondary text-white'}
                            style={{ padding: '8px 0' }}
                        >
                            <Col>{data.username}</Col>
                            <Col>{data.email}</Col>
                            <Col>{data.phone}</Col>
                            <Col>{data.message}</Col>
                        </Row>
                ))}
                </Col>
            </Row>
        </Container>
    );
}

export default Request;